var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNestMiddlewareJsSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 15.997,
    y1: 993,
    x2: 15.997,
    y2: 1021,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1023)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0844"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_nest_middleware_js") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.488,2a1.753,1.753,0,0,0-.564.1c1.611,1.058-.28,2.594.6,3.9A2.234,2.234,0,0,1,19.6,3.765c.285-.237.467-.322.406-.714C19.91,2.409,19.054,2,18.488,2Zm2.3.414c-.222,1.123-.5,1.164-1.323,1.887a1.82,1.82,0,0,0-.528,2.191c-3.4-1.32-7.758-2.118-10.953.166-1.149.821-1.851,2-3.268,2.481C3.8,9.452,2.9,9.36,2.328,10.268A1.413,1.413,0,0,0,2.384,12.1c.17.175.5.287.636.465.079.1.077.2.152.333a2.586,2.586,0,0,0,.564.828c.146.121.652.239.738.368.107.161-.173.8.062.9.159.073.622-.744.667-.816-.092.643-.213,1.784.51.834.343-.451.364-.6.941-.7a8.36,8.36,0,0,1,9.739,7.506c-.108-.5-.761-1.3-1.369-1.11-.259.08-.355.527-.525.786a3.75,3.75,0,0,1-.785.868,4.657,4.657,0,0,0-.072-1.452c-.182.748-.547,1.989-1.466,1.788a1.652,1.652,0,0,1-1.328-1.142c-.119-.76.684-1.651-.607-1.714-2.59-.127-1.991,3.682-.462,4.675a3.272,3.272,0,0,0-1.015.283A6.893,6.893,0,0,0,19.04,19.889a7.046,7.046,0,0,1-.646,4.79,6.9,6.9,0,0,1-1.23,1.668c-.3.3-.894.63-1.089.941A13.427,13.427,0,0,0,19.6,26.32,11.647,11.647,0,0,1,15.1,30a11.59,11.59,0,0,0,9.3-5.909,11.657,11.657,0,0,1-1.945,4.668,11.531,11.531,0,0,0,4.975-7.783,11.655,11.655,0,0,1,.209,3.5A12.418,12.418,0,0,0,29.53,13.91a15.755,15.755,0,0,0-1.689-3.962A14.838,14.838,0,0,0,26.9,8.554c-.133-.173-.844-.806-.844-1q-.009.029-.015,0c0,3.266-3.5,5.311-6.431,4.463a5,5,0,0,0,4.56-4.288A4.988,4.988,0,0,0,20.789,2.414Z",
    style: {
      fillRule: "evenodd",
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.64,27.114l1.67-1a1.51,1.51,0,0,0,1.31,1.07c.67,0,1.1-.26,1.1-1.29v-7h2v7a2.78,2.78,0,0,1-2.435,3.087,2.839,2.839,0,0,1-.625,0,3.181,3.181,0,0,1-3.07-1.87m7.29-.22,1.67-1a2.23,2.23,0,0,0,2,1.24,1.181,1.181,0,0,0,1.431-.859h0c.007-.03.014-.06.019-.091,0-.7-.56-1-1.49-1.36L25,24.6c-1.48-.63-2.46-1.42-2.46-3.09A2.74,2.74,0,0,1,25.3,18.792h0c.081,0,.161,0,.242.012a3,3,0,0,1,2.91,1.64l-1.59,1a1.39,1.39,0,0,0-1.32-.88.889.889,0,0,0-.993.773.759.759,0,0,0-.007.107c0,.61.38.86,1.26,1.24l.51.22C28,23.654,29,24.414,29,26.134s-1.45,2.85-3.39,2.85a3.929,3.929,0,0,1-3.73-2.09",
    style: {
      fill: "#f7df1e"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNestMiddlewareJsSvgrepoCom);
export default __webpack_public_path__ + "static/media/nest-middleware-js-svgrepo-com.e1a6fcb5559ea88bcca2c07b260ca71f.svg";
export { ForwardRef as ReactComponent };